/**
 * 按剩余点数从在线套餐中推荐最小够用档（bg_product.quota_amount）。
 * @param {number} remainingQuota 还需点数
 * @param {Array} packages Portal 套餐列表
 */
export function pickProductForQuota(remainingQuota, packages) {
  if (!packages || !packages.length) {
    return null
  }
  const sorted = [...packages].sort((a, b) => (a.quotaAmount || 0) - (b.quotaAmount || 0))
  const need = Math.max(Number(remainingQuota) || 0, 1)
  const matched = sorted.find(item => (item.quotaAmount || 0) >= need)
  return matched || sorted[sorted.length - 1]
}

export function resolveRemainingNeed(detail) {
  if (!detail) {
    return 0
  }
  const quota = detail.remainingQuota
  if (quota != null && quota > 0) {
    return quota
  }
  return Math.max(detail.remainingChars || 0, 0)
}
